const INITIAL_STATE = {
  turmas: [],
  novaTurma: null,
  erro: null
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "ERRO_TURMAS":
      return {...state, erro: action.erro};
    case "SALVAR_TURMAS":
      return {...state, novaTurma: action.turma};
    case 'REMOVER_TURMAS':
      return {...state, turmas: state.turmas.filter((turma) => { return turma.id !== action.id })};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/TurmaReducer.js